// src/services/api.js

import axios from 'axios';

const apiClient = axios.create({
  baseURL: '/api', // Ini sudah benar
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor yang disempurnakan dengan logging yang lebih baik
apiClient.interceptors.request.use(
  (config) => {
    let token = null;
    let tokenType = 'None'; // Untuk logging

    // Cek apakah ini rute admin
    if (config.url.startsWith('/admin')) {
      tokenType = 'Admin';
      token = localStorage.getItem('admin_token');
    } 
    // Cek apakah ini rute peserta (secara eksplisit)
    else if (
        config.url.startsWith('/sessions') || 
        config.url.startsWith('/packages') || 
        config.url.startsWith('/tests') ||
        config.url.startsWith('/verify')
    ) {
      tokenType = 'Participant';
      token = localStorage.getItem('session_token');
    }
    
    // Logging yang detail untuk debugging
    console.log(`[API Interceptor] Request to: ${config.url}`);
    console.log(`[API Interceptor] Detected Route Type: ${tokenType}`);

    if (token) {
      console.log(`[API Interceptor] Attaching Token: Bearer ${token.substring(0, 10)}...`);
      config.headers['Authorization'] = `Bearer ${token}`;
    } else {
      console.warn(`[API Interceptor] No token found for this route type.`);
    }
    
    return config;
  },
  (error) => {
    // Logging untuk request error
    console.error("[API Interceptor] Request Error:", error);
    return Promise.reject(error);
  }
);

// Tambahkan interceptor untuk respons agar lebih mudah debug
apiClient.interceptors.response.use(
  (response) => {
    // Jika respons sukses, langsung kembalikan
    return response;
  },
  (error) => {
    // Logging detail untuk response error
    if (error.response) {
      console.error("[API Interceptor] Response Error:", {
        url: error.config.url,
        status: error.response.status,
        data: error.response.data,
      });
    } else if (error.request) {
      console.error("[API Interceptor] No Response Received:", error.request);
    } else {
      console.error("[API Interceptor] Error setting up request:", error.message);
    }
    return Promise.reject(error);
  }
);


export default apiClient;